import React, { Component } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { getErrorString } from "../display/ErrorStrings";
import { APPNAME } from "../components/Constants";

import ContinueIcon from "@material-ui/icons/FastForwardOutlined";
import LogoutIcon from "@material-ui/icons/ExitToAppOutlined";

import { withTranslation } from "react-i18next";

class InfoPage extends Component {
  constructor(props) {
    super(props);
    const root = document.getElementById("root");
    const use_static_logout_page = root.getAttribute("use_static_logout_page");
    this.state = {
      errorString: "",
      userName: "",
      companyName: "",
      lastLogin: "",
      sessionTime: "",
      messagesShowing: false,
      messages: [],
      logoFile: "",
      secureToken: "",
      use_static_logout_page: use_static_logout_page,
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
  }

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      this.handleContinue(e);
    }
  };

  handleLogout(e) {
    e.preventDefault();
    fetch("on_logout", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.state.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        if (window.sco_return_url) {
          window.location.href = window.sco_return_url;
        } else {
          if (this.state.use_static_logout_page === "1") {
            this.props.history.push("/staticlogout");
          } else {
            this.props.history.push("/");
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleContinue(e) {
    if (this.props.nextPage) {
      this.props.history.push({
        pathname: this.props.nextPage,
        state: { secureToken: this.props.reply.secureToken },
      });
    } else {
      this.props.history.push({
        pathname: "/main",
        state: { secureToken: this.props.reply.secureToken },
      });
    }
  }

  componentDidMount() {
    let { t } = this.props;
    if (this.props.errorString.length > 0) {
      this.setState({ errorString: this.props.errorString });
    } else {
      var reply = this.props.reply;
      if (reply.authenticated === false) {
        this.props.history.push("/expired");
      } else {
        this.setState({ userName: reply.userName });
        this.setState({ companyName: reply.companyName });
        this.setState({ lastLogin: reply.lastLogin });
        this.setState({
          sessionTime:
            t("after.label") + reply.sessionTime + t("minutesInactivity.label"),
        });
        this.setState({ logoFile: reply.logoFileName });
        this.setState({ bankRealm: reply.bankRealm });
        this.setState({ secureToken: reply.secureToken });
        if (reply.numMessages > 0) this.setState({ messagesShowing: true });
        this.setState({ messages: reply.messages });
        if (reply.error) {
          this.setState({ errorString: reply.errorString });
        }
      }
    }
  }

  render() {
    let items = this.state.messages;
    let { t } = this.props;
    /*const changeLanguage = lng => {
			i18n.changeLanguage(lng);
		};*/
    //changeLanguage('fr');
    //i18n.changeLanguage('fr');
    return (
      <div>
        <AppBar position="static">
          <Toolbar>
            {this.state.logoFile.length === 0 && (
              <Typography variant="h6" color="inherit">
                {APPNAME}
              </Typography>
            )}
            {this.state.logoFile.length > 0 && (
              <img
                src={
                  "logo/logo_" +
                  this.state.imageFile +
                  "?secureToken=" +
                  this.props.secureToken
                }
                alt="Not Available"
                style={{ maxWidth: "140px", maxHeight: "60px" }}
              />
            )}

            <p style={{ width: 600, marginRight: "auto", marginLeft: "auto" }}>
              {" "}
              {t("company.label")} {this.state.companyName} &nbsp;&nbsp;{" "}
              {t("user.label")} {this.state.userName}{" "}
            </p>
            <Button
              style={{ right: 20 }}
              color="inherit"
              onClick={this.handleLogout}
            >
              <LogoutIcon />
              &nbsp;{t("logout.label")}
            </Button>
          </Toolbar>
        </AppBar>
        {this.state.errorString.length > 0 && (
          <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
        )}
        {this.state.errorString.length === 0 && (
          <div
            style={{
              width: "100%",
              marginRight: "auto",
              marginLeft: "auto",
              padding: 30,
            }}
          >
            <Paper elevation={4}>
              <Typography variant="h6" component="h3">
                &nbsp;&nbsp;{t("hello.label")} {this.state.userName}
              </Typography>
              <List>
                <ListItem>
                  <ListItemText
                    primary={t("lastlogin.label")}
                    secondary={this.state.lastLogin}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t("automaticLogout.label")}
                    secondary={this.state.sessionTime}
                  />
                </ListItem>
              </List>
              <Typography component="p"></Typography>
            </Paper>
            <div
              style={{ display: this.state.messagesShowing ? "block" : "none" }}
            >
              <h2> {t("alerts.label")}</h2>
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("subject.header")}</TableCell>
                      <TableCell>{t("message.header")}</TableCell>
                      <TableCell>{t("datePosted.header")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item) => {
                      return (
                        <TableRow key={item.id}>
                          <TableCell component="th" scope="row">
                            {item.subject}
                          </TableCell>
                          <TableCell>{item.text}</TableCell>
                          <TableCell>{item.date}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Paper>
            </div>
            <br></br>
            <Button
              variant="outlined"
              autoFocus
              disableRipple
              visibleclassname="focus"
              onClick={this.handleContinue}
              color="primary"
              onKeyPress={(e: KeyboardEvent<HTMLDivElement>) =>
                this.handleKeyPress(e)
              }
            >
              <ContinueIcon />
              &nbsp;{t("continue.button")}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(InfoPage);
